import React from "react";
import { connect } from "react-redux";
import {injectIntl} from "react-intl";

import Checkbox from '@mui/material/Checkbox';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';

import PropTypes from "prop-types";
import {filterGroupInterface} from "../../../../../interfaces/filterInterface";
import {toggleFilterArrayValue} from "../../../../visComponents/navigation/newFilters/filtersBody";
import {setSelectedFilters} from "../../../../../actions/actionFunctions";
import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS, PRODUCT_JOURNEY_ANALYTIC_EVENTS} from "../../../../../analytics";
import {IS_PRODUCT_JOURNEY} from "../../../../../config";
import {featureGroupInterface} from "../../../../../interfaces/featureInterface";
import {getFixedFilterValueName, weShouldHideFilterValue} from "../../../filtersHardcode";

const GroheFiltersValues = (props) => {
  const {availableFilter, selectedFilters, setSelectedFilters, shopPageOpened} = props;

  const setActiveFilterValue = (filterId, filterGroupId, filterValueText, selected) => {
    const underscoredText = Analytics.getSkuForAnalytics({dbFeature: {sku: filterValueText}}, false);

    if (IS_PRODUCT_JOURNEY) {
      Analytics.sendClickEvent(
        selected
          ? PRODUCT_JOURNEY_ANALYTIC_EVENTS.productFeaturesFiltersValuerUnChecked + underscoredText
          : PRODUCT_JOURNEY_ANALYTIC_EVENTS.productFeaturesFiltersValueChecked + underscoredText
      )
    } else {
      Analytics.sendClickEvent(
        selected
          ? LOOK_JOURNEY_ANALYTIC_EVENTS.lookFeaturesFiltersValuerUnChecked + underscoredText
          : LOOK_JOURNEY_ANALYTIC_EVENTS.lookFeaturesFiltersValueChecked + underscoredText
      )
    }
    setSelectedFilters(toggleFilterArrayValue([...selectedFilters], {filterId, filterGroupId}));
  };

  return (
    <div className={shopPageOpened ? "g-filters" : "g-filters margin-l-16"}>
      <FormGroup>
        {availableFilter.values.map(filterValue => {
          // we did this check already in the getAvailableFiltersForReceivedFilters function
          // if (COUNTERTOP_GROUP.includes(featureGroup.partId) && featureGroup && featureGroup.filtersReceived
          //   && !featureGroup.filtersReceived.includes(filterValue.id)) {
          //   return null
          // }
          if (weShouldHideFilterValue(filterValue)) {
            return null
          }
          const selected = selectedFilters.find((filter) => {
            return filter.filterGroupId === availableFilter.id && filter.filterId === filterValue.id
          })
          const checkboxClick = () => {
            return setActiveFilterValue(filterValue.id, availableFilter.id, filterValue.displayText, selected)
          }
          return (
            <FormControlLabel
              label={getFixedFilterValueName(filterValue)}
              className="g-filters__item"
              key={filterValue.id}
              control={<Checkbox checked={!!selected} className="g-filters__item-checkbox" onChange={checkboxClick} />}
            />
          )}
        )}
      </FormGroup>
    </div>
  )
};

GroheFiltersValues.propTypes = {
  availableFilter: PropTypes.shape(filterGroupInterface),
  featureGroup: PropTypes.shape(featureGroupInterface),
}

const mapStateToProps = (store) => {
  const {selectedFilters} = store.filterState;
  const {shopPageOpened} = store.shopState;
  return {
    selectedFilters,
    shopPageOpened,
  };
};

const mapDispatchToProps = {
  setSelectedFilters
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(GroheFiltersValues)
);
